import React from "react";
import { Container, Typography, Button, Grid, Paper } from "@mui/material";
import "@fortawesome/fontawesome-free/css/all.min.css"; // Importar los iconos de Font Awesome

const Contact = () => {
  return (
    <section
      id="contact"
      className="py-5"
      style={{ backgroundColor: "#f9f9f9", paddingTop: "80px" }}
    >
      {" "}
      {/* Color de fondo suavizado */}
      <Container>
        <Typography variant="h4" align="center" gutterBottom>
          Contactanos
        </Typography>
        <Grid container justifyContent="center">
          <Grid item lg={6}>
            {/* Datos de contacto */}
            <Paper
              elevation={3}
              style={{
                padding: "20px",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <Typography variant="h4">FC Zinguería</Typography>
              <Typography>
                <strong>Dirección:</strong> Boulevard y Paseo 104 - N° 412,
                Villa Gesell (7165), Bs.As, Argentina
              </Typography>
              <Typography>
                <strong>Tel:</strong>{" "}
                <a
                  href="tel:+5492267445628"
                  style={{ color: "black", textDecoration: "none" }}
                >
                  +54 9 (2267) 445628
                </a>
              </Typography>
            </Paper>

            {/* Google Maps */}
            <Paper
              elevation={3}
              style={{
                marginBottom: "20px",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d198.4954981752107!2d-56.975586058283916!3d-37.249416411220935!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959b61027b711025%3A0xd33e9da35b05ebe8!2sFC%20Zingueria!5e0!3m2!1ses!2ses!4v1729701116477!5m2!1ses!2ses"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              ></iframe>
            </Paper>

            {/* Botones de contacto */}
            <Grid container spacing={2} justifyContent="center">
              {/* Botón de WhatsApp */}
              <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  color="#fff"
                  href="https://wa.me/5492267445628"
                  target="_blank"
                  fullWidth
                  style={{ display: "flex", alignItems: "center" }} // Alinear contenido
                >
                  <i
                    className="fab fa-whatsapp"
                    style={{ marginRight: "8px" }}
                  ></i>{" "}
                  {/* Separar ícono del texto */}
                  WhatsApp
                </Button>
              </Grid>

              {/* Botón de Llamar */}
              <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  color="#fff"
                  href="tel:+5492267445628"
                  fullWidth
                  style={{ display: "flex", alignItems: "center" }} // Alinear contenido
                >
                  <i
                    className="fas fa-phone-alt"
                    style={{ marginRight: "8px" }}
                  ></i>{" "}
                  {/* Separar ícono del texto */}
                  Llamar
                </Button>
              </Grid>

              {/* Botón de Instagram */}
              <Grid item xs={12} md={4}>
                <Button
                  variant="contained"
                  color="#fff"
                  href="https://www.instagram.com/fc_zingueria"
                  target="_blank"
                  fullWidth
                  style={{ display: "flex", alignItems: "center" }} // Alinear contenido
                >
                  <i
                    className="fab fa-instagram"
                    style={{ marginRight: "8px" }}
                  ></i>{" "}
                  {/* Separar ícono del texto */}
                  Instagram
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
};

export default Contact;
